import { render, staticRenderFns } from "./steelDefects.vue?vue&type=template&id=2cc15b73&scoped=true"
import script from "./steelDefects.vue?vue&type=script&lang=js"
export * from "./steelDefects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc15b73",
  null
  
)

export default component.exports